import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackDeleteWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackDeleteWishList = (parameters: TrackDeleteWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "delete_wishlist", ...parameters }, options);
};

export default trackDeleteWishList;
